
/* ============================== src/components/discussion/Provider.jsx ============================== */
// src/components/discussion/Provider.jsx
import { DiscussionContext } from "./context";

export function DiscussionProvider({ value, children }) {
  return (
    <DiscussionContext.Provider value={value}>
      {children}
    </DiscussionContext.Provider>
  );
}
